import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useRef } from "react";
import axios from "axios";
import axiosInstance from "../../../lib/axios";
import {
  Box,
  Grid,
  Button,
  Typography,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import {
  KeyboardArrowLeft as KeyboardArrowLeftIcon,
  NavigateNext as NavigateNextIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  CancelPresentation as CancelPresentationIcon,
  Flag,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import StepConnector from "@mui/material/StepConnector";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { useNavigate } from "react-router-dom";
import AuthHeader from "../../../Auth";
import PartyStepper1 from "./PartyStepper1";
import PartyStepper2 from "./PartyStepper2";
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from "../../../GlobalFunction/CrudButtons";

const steps = ['Vendor Details', 'Branch Details'];
const CustomStepConnector = styled(StepConnector)(({ theme }) => ({
  '& .MuiStepConnector-line': {
    borderColor: '#e0e0e0',
    borderTopWidth: 3,
    borderRadius: 1,
    margin: '7px 30px 20px 30px'
  },
}));
const CustomStepIcon = styled('div')(({ theme, ownerState }) => ({
  width: 40,
  height: 40,
  border: '3px solid',
  borderColor: ownerState.active ? '#635bff' : '#e0e0e0',
  borderRadius: '50%',
  backgroundColor: 'transparent',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: ownerState.active ? '#635bff' : '#999',
  fontSize: '1.2rem',
  fontWeight: 'bold',
}));

const CustomStepLabel = styled(StepLabel)({
  flexDirection: 'column',
  '& .MuiStepLabel-labelContainer': {
    marginTop: '5px',
  },
});

const PartyMaster = () => {
  const location = useLocation();
  const [UserId, setUserId] = useState(sessionStorage.getItem("UserId"));
  const [Mode, setMode] = useState('add');
  const [AllButtonTextDisabled, setAllButtonTextDisabled] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [PartyRetrieveData, setPartyRetrieveData] = useState([]);
  const [GridData, setGridData] = useState([]);
  const [SiteByData, setSiteByData] = useState([]);
  const [AllfieldStepperData, setAllfieldStepperData] = useState({});
  const [Company, setCompany] = useState([]);
  const [MainData, setMainData] = useState([]);
  const [PartyId, setPartyId] = useState(-1);
  const [openDialog, setopenDialog] = useState(false);
  const [Category, setCategory] = useState("SP");
  const [Status, setStatus] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAllData = async () => {
      await fetchCities();
      if (location.state?.PartyId) {
        let id = location.state.PartyId;
        let Cat = location.state.PartyId.PartyCat;
        let flag = "R";
        await fetchPartyData(id, flag, Cat);
      } else {
        setMode("add");
      }
    }
    fetchAllData();
  }, [location]);

  const fetchCities = async () => {
    const response = await axiosInstance.get(
      `CoMst/getCoMstdrp`,
    );
    setCompany(response.data.Data);
  };

  const fetchPartyData = async (id, flag, Cat) => {
    try {
      const response = await axiosInstance.post(`PartyMst/RetrivePartyMstAll`, { PartyId: id, Flag: flag, PartyCat: Cat },);
      console.log("response-data ", response);
      if (response.data.Status === 0) {
        setPartyRetrieveData(response.data.Data.PartyMstList);
        setMainData(response.data.Data.PartyMstList)
        setPartyId(response.data.Data.PartyMstList[0].PartyId);
        setStatus(response.data.Data?.PartyMstList[0].Status);
        setCategory(response.data.Data.PartyMstList[0].PartyCat);
        let TableGridData = response.data.Data.PartyMstList[0].PartyMstDtlList.map(obj => ({ ...obj, PartyAbrv: response.data.Data.PartyMstList[0].PartyAbrv }))
        // setGridData(response.data.Data.PartyMstList[0].PartyMstDtlList);
        setGridData(TableGridData);
        setAllfieldStepperData(response.data.Data.PartyMstList[0]);
        setSiteByData([]);
        setMode("view");
        setAllButtonTextDisabled(false);

      } else {
        setMode("add");
        setAllButtonTextDisabled(true);

      }

    }
    catch (err) {
      console.log("err", err);
    }
  }

  function hasProperty(obj, property) {
    return property in obj;
  }

  const handleToNextClick = (obj) => {
    obj.AccledId = obj.AccledId === "" ? 1 : obj.AccledId;
    console.log("Next Step", obj)
    let TableData = [...GridData];
    console.log("TableData", TableData);



    if (Mode === "add") {
      let Newobj = {
        "PartyId": 1,
        "MainBranch": "1",
        "PartyAltCode": obj.PartyAltCode,
        "AreaName": obj.AreaName,
        "PartyCat": obj.PartyCat,
        "Addr": obj.Addr,
        "PartyAbrv": obj.PartyAbrv,
        "RegAdd": "",
        "CityId": 1,
        "WorkAdd": obj.WorkAdd,
        "PinId": obj.PinId,
        "PinCode": obj.PinCode,
        "TelNo": obj.TelNo,
        "Email": obj.Email,
        "Website": "",
        "ContactPerson": obj.ContactPerson,
        "MobileNo": obj.MobileNo,
        "Sst": "",
        "Cst": "",
        "IeCode": obj.IeCode,
        "ExciseCode": "",
        "Vat": "",
        "PanNo": obj.PanNo,
        "TanNo": obj.TanNo,
        "SmsMobileno": "",
        "AccledId": obj.AccledId,
        "CoMstId": 1,
        "RdUrd": obj.RdUrd,
        "GsttinNo": obj.GsttinNo,
        "MsmeFlag": obj.MsmeFlag,
        "MsmeNo": obj.MsmeNo,
        "MsmeTr": obj.MsmeTr,
        "MsmeAct": obj.MsmeAct,
        "MsmeClass": obj.MsmeClass,
        "Status": obj.Status === "1" ? "1" : "0",
        "Remark": obj.Remark,
        "DBFLAG": "I"
      }

      TableData[0] = Newobj;

    } else {

      for (let key in obj) {
        TableData[0][key] = obj[key];
        console.log(key, obj[key]);

      }
      TableData[0]["DBFLAG"] = "U";


    }

    console.log("TAbleDAta", TableData);

    setGridData(TableData);
    console.log("Step1", obj);
    if (hasProperty(obj, "AreaName")) delete obj.AreaName;
    setAllfieldStepperData(obj);
    setActiveStep(1);
  };

  const handleClickPrev = () => {
    fetchPartyData(PartyId, "P", Category);
  };

  const handleClickNext = () => {
    fetchPartyData(PartyId, "N", Category);
  };

  const handleClickAdd = () => {
    setAllButtonTextDisabled(prev => !prev);
    setMode("add");
    setGridData([]);
    setActiveStep(0);
  };

  const handleClickView = async () => {
    let Flag = await checkAndLock(PartyId, "MstParty", "PartyId");
    switch (Flag) {
      case 0:
        setMode("view");
        setAllButtonTextDisabled(prev => !prev);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }
  };

  const handleClickDelete = async () => {
    let Flag = await checkAndLock(PartyId, "MstParty", "PartyId");
    switch (Flag) {
      case 0:
        setopenDialog(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }
  };

  const handleConfirmDelete = async () => {
    if (PartyId !== -1) {
      try {
        const response = await axiosInstance.post(`PartyMst/RetrivePartyMstAll`, { PartyId, Flag: "D", PartyCat: Category },);
        if (response.data.Status === 0) {
          toast.success(response.data.Message);
          fetchPartyData(PartyId, "L", Category);
        } else {
          toast.success(response.data.Message);
        }
      }
      catch (err) {
        console.log("err", err);
      }
    }
    let Flag = await UnLock(PartyId, "MstParty", "PartyId");
    switch (Flag) {
      case 0: break;
      case 1: toast.info("Problem To Unlocked Record", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });
    }
    setopenDialog(false);
  };

  const handleCancel = async () => {
    let Flag = await UnLock(PartyId, "MstParty", "PartyId");
    switch (Flag) {
      case 0: break;
      case 1: toast.info("Problem To Unlocked Record", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });
    }
    setopenDialog(false);
  };

  const handleMoveBack = () => { navigate(`/partytable`) }

  const handleStepClick = (step) => {
    if (Mode === "view" && !AllButtonTextDisabled) {
      setActiveStep(step);
    }
  };

  return (
    <Grid>
      <ToastContainer />
      <Box className="form-container">
        <Dialog
          open={openDialog}
          onClose={handleCancel}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this record?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              sx={{
                backgroundColor: '#635bff',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#1565c0',
                  color: 'white'
                }
              }}
              onClick={handleConfirmDelete}
            >
              Yes
            </Button>
            <Button
              sx={{
                backgroundColor: '#635bff',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#1565c0',
                  color: 'white'
                }
              }}
              onClick={handleCancel}
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
        <Grid container spacing={2} className="rasidant_grid">
          {/* Header Section */}
          <Grid item xs={12} className='form_title'
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginTop: '20px',
              flexDirection: { xs: 'column', sm: 'row', md: 'row' }
            }}
          >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                onClick={handleClickPrev}
                disabled={AllButtonTextDisabled}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                className='three-d-button-next'
                onClick={handleClickNext}
                disabled={AllButtonTextDisabled}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>

            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Party Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="Vendor Master"
                mode={Mode}
                onAdd={handleClickAdd}
                onEdit={handleClickView}
                onDelete={handleClickDelete}
                onExit={handleMoveBack}
                readOnlyMode={!AllButtonTextDisabled}
                onPrevious={handleClickPrev}
                onNext={handleClickNext}
              />
            </Grid>
          </Grid>

          {/* Stepper Section */}
          <Grid item xs={12}>

            <Stepper
              activeStep={activeStep}
              connector={<CustomStepConnector />}
              alternativeLabel

            >
              {steps.map((label, index) => (
                <Step
                  key={label}
                  onClick={(event) => {
                    event.preventDefault(); // Prevent default behavior
                    handleStepClick(index); // Handle the step click logic
                  }}

                >
                  <CustomStepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon
                        ownerState={{ ...props, active: activeStep === index }}

                      >
                        {index + 1}
                      </CustomStepIcon>
                    )}
                  >
                    {label}
                  </CustomStepLabel>
                </Step>
              ))}
            </Stepper>

          </Grid>

          {/* Content Based on Active Step */}
          <Grid item xs={12}>
            {activeStep === 0 ? (
              <PartyStepper1
                AllButtonTextDisabled={AllButtonTextDisabled}
                setAllButtonTextDisabled={setAllButtonTextDisabled}
                Mode={Mode}
                PartyRetrieveData={PartyRetrieveData}
                setMode={setMode}
                fetchPartyData={fetchPartyData}
                handleToNextClick={handleToNextClick}
                setPartyRetrieveData={setPartyRetrieveData}
                setSiteByData={setSiteByData}
                SiteByData={SiteByData}
                setGridData={setGridData}
                MainData={MainData}
                Status={Status}
                setStatus={setStatus}
                Company={Company}
                PartyId={PartyId}
                UserId={UserId}
                Category={Category}
              />
            ) : (
              <PartyStepper2
                GridData={GridData}
                setActiveStep={setActiveStep}
                setGridData={setGridData}
                Company={Company}
                AllfieldStepperData={AllfieldStepperData}
                Mode={Mode}
                PartyId={PartyId}
                fetchPartyData={fetchPartyData}
                AllButtonTextDisabled={AllButtonTextDisabled}
                setAllButtonTextDisabled={setAllButtonTextDisabled}
                UserId={UserId}
                Category={Category}
                setCategory={setCategory}
              />
            )}
          </Grid>

          {/* Buttons for form actions */}
        </Grid>
      </Box>
    </Grid>
  )
}

export default PartyMaster;